import AbstractClientStore from './AbstractClientStore';

class LocalClientStore extends AbstractClientStore {}

LocalClientStore.setStorage(localStorage);

export default LocalClientStore;
